module.exports = __webpack_public_path__ + "eb69debd5434a3f8260d59484e015d07.svg";